import {
  $checkboxAll,
  $accordionHead,
  $checkboxOptions
} from "../../lib/gt/myProgress/elements";


import {
  handleAccordionHeadClick
} from "../../lib/gt/myProgress/accordion";

import {
  setFormInputValue,
  handleCheckOptionClick,
  handleCheckAllOptionsClick,
  checkOrUncheckAllOptionsIfNeeded
} from "../../lib/gt/myProgress/checkBox";

$checkboxAll.click(handleCheckAllOptionsClick);
$checkboxOptions.click(handleCheckOptionClick);
$accordionHead.click(handleAccordionHeadClick);

$(checkOrUncheckAllOptionsIfNeeded(), setFormInputValue());
